import { mountApp } from '@/main'
import App from '@/views/generic/nps/survey_modal.vue'

if (document.getElementById('nps-toggle-btn')) {
  const locale = document.getElementById('main').dataset.userLocale || 'en'
  mountApp({
    App,
    mountPoint: '#nps-survey-modal',
    locale
  })
}
